import { axios } from '@/utils/request'

export function getWorkTable (parameter) {
  return axios({
    url: '/order/business/getWorkTable',
    method: 'get',
    params: parameter
  })
}
export function getTime(parameter) {
  return axios({
    url: '/order/merchantOrder/getOrderTimeScope',
    method: 'get',
    params: parameter
  })
}
